import { MutationTree } from 'vuex';
import { StatisticState } from './types';

export const mutations: MutationTree<StatisticState> = {
    
    setCallMessagesCount: (state, data) => {
        state.callStatisticGroupMessageCount = data;
    },
    setCallStatisticGroup: (state, data) => {
        state.callStatisticGroup = data;
    },
    setCallIncomingMessagesCount: (state, data) => {
        state.callStatisticGroupIncomingMessageCount = data;
    },
    setCallStatisticGroupIncoming: (state, data) => {
        state.callStatisticGroupIncoming = data;
    },

    setCallStatisticDetail: (state, data) => {
        state.callStatisticDetail = data
    },
    pushCallStatisticDetail: (state, data) => {
        state.callStatisticDetail = state.callStatisticDetail.concat(data)
    },
    setCallStatisticDetailFlag: (state, data) => {
        state.callStatisticDetailFlag = data
    },
    setCallStatisticDetailIncoming: (state, data) => {
        state.callStatisticDetailIncoming = data;
    }
};